import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import _ from "lodash";

const initialState = {
  liveChatTemplate: {},
  configIC: {
    fieldID: "",
    value: "",
  },
  advancedConfig: {},
  allChatBot: [],
  allUserIC: [],
  completedMessages: [],
  assignedMessages: [],
  isLoadingMessages: true,
  messageDetails: [],
  isLoadingMessageDetails: true,
  selectedMessage: {},
  statusIC: "",
  tags: [],
  addTag: {
    visible: false,
    interaction_id: "",
    interactionTags: [],
    interactiondetail_id: "",
  },
  currentPageIC: 1,
  recordPerPageIC: null,
  hasMoreIC: true,
  isActive: 0,
  newMessage: {},
  newMessageInternal: {},
  quickMessages: [],
  addAgent: {
    isLoading: false,
    visible: false,
    interaction_id: "",
    note_content: "",
    username_dest: "",
    username_source: "",
  },
  transferAgent: {
    isLoading: false,
    visible: false,
    interaction_id: "",
    note_content: "",
    username_dest: "",
    username_source: "",
  },
  userToAdd: [],
  searchMessages: [],
  isSearchMessages: false,
  indexMessage: null,
  facebookPost: {},
  listSocialRegister: [],
  stateList: [],
  filter: {
    open: false,
    search_list: [
      {
        name_field: "create_time",
        value_search: moment(new Date())
          .subtract(7, "days")
          .format("YYYY-MM-DDT00:00:00"),
        upper_bound: moment(new Date())
          .add(1, "days")
          .format("YYYY-MM-DDT00:00:00"),
      },
    ],
  },
  search: {
    search_text: "",
    open: false,
  },
  meta: {
    limit: 20,
    page: 1,
    hasMore: true,
  },
  listInteractionSelected: [],
  socialPage: [],
  internalMessages: [],
  internalMessagesSearch: [],
  metaGroup: {
    limit: 20,
    page: 1,
    hasMore: true,
  },
  isLoadingInternalMessages: true,
  addGroup: {
    visible: false,
  },
  selectedSearchMessage: {
    id: "",
    position: 0,
  },
  productList: [],
  productListMeta: {
    limit: 20,
    page: 1,
    hasMore: true,
  },
  productSelected: {},
  addRecordIC: {
    visible: false,
  },
  customer: {},
  isUnseen: false,
  memberList: [],
  userById: {},
  buttonsIntegration: [],
  isLoadingCommentActions: {
    like: "",
    hide: "",
    remove: "",
  },
  addGroupMember: {
    visible: false,
    group_name: "",
    interaction_id: "",
    list_member: [],
    tenant_id: "",
  },
  forwardMessage: {
    visible: false,
    id: "",
    data: {
      owner: "",
      reply_content_file_name: "",
      reply_content_file_url: "",
      reply_create_by: "",
      reply_interaction_type: "",
      reply_location_lat: "",
      reply_location_long: "",
      reply_mess_text: "",
      reply_sender_type: "",
      reply_to_id: "",
    },
  },
  updateMessage: {
    visible: false,
    message: {},
  },
  pinMessage: {
    visible: false,
    message: {},
  },
  pinMessageList: [],
};

const slice = createSlice({
  name: "icChatWidget",
  initialState,
  reducers: {
    getLiveChatTemplate() {},
    getLiveChatTemplateResult(state, action) {
      state.liveChatTemplate = action.payload;
    },
    updateLiveChatTemplate() {},
    getConfigIC() {},
    getConfigICResult(state, action) {
      state.configIC = action.payload;
    },
    getAdvancedConfigIC() {},
    getAdvancedConfigICResult(state, action) {
      state.advancedConfig = action.payload;
    },
    getAllUserIC() {},
    getAllUserICResult(state, action) {
      state.allUserIC = action.payload;
    },
    getChatBotIC() {},
    getChatBotICResult(state, action) {
      state.allChatBot = action.payload;
    },
    getListMessagesAssignedIC(state) {
      state.isLoadingMessages = true;
    },
    getListMessagesAssignedICResult(state, action) {
      if (state.meta.page === 1) {
        state.assignedMessages = action.payload;
      } else {
        state.assignedMessages = state.assignedMessages.concat(action.payload);
      }
      state.isLoadingMessages = false;
      if (action.payload?.length < 10) {
        state.meta = {
          ...state.meta,
          hasMore: false,
        };
      }
    },
    setListMessagesAssignedIC(state, action) {
      if (action.payload.type === "reset") {
        state.assignedMessages = [];
      } else if (action.payload.type === "add") {
        state.assignedMessages = _.uniqBy(
          [action.payload.data, ...state.assignedMessages],
          "interaction_id"
        );
        state.isActive = state.isActive + 1;
      } else if (action.payload.type === "seen") {
        state.assignedMessages = action.payload.data;
      } else {
        const index = state.assignedMessages.findIndex(
          (item) => item?.interaction_id === action.payload?.data
        );
        if (index > -1) {
          const newAssignedMessages = [...state.assignedMessages];
          newAssignedMessages.splice(index, 1);
          state.assignedMessages = newAssignedMessages;
        }
      }
    },
    getListMessagesCompletedIC(state) {
      state.isLoadingMessages = true;
    },
    getListMessagesCompletedICResult(state, action) {
      if (state.meta.page === 1) {
        state.completedMessages = action.payload;
      } else {
        state.completedMessages = state.completedMessages.concat(
          action.payload
        );
      }
      state.isLoadingMessages = false;
      if (action.payload?.length < 10) {
        state.meta = {
          ...state.meta,
          hasMore: false,
        };
      }
    },

    setListMessagesCompletedIC(state, action) {
      if (action.payload.type === "seen") {
        state.completedMessages = action.payload.data;
      }
    },
    $currentPageIC(state, action) {
      state.currentPageIC = action.payload;
    },
    $recordPerPageIC(state, action) {
      state.recordPerPageIC = action.payload;
    },
    $isActive(state, action) {
      state.isActive = action.payload;
    },
    getMessageDetailsIC(state) {
      state.isLoadingMessageDetails = true;
    },
    getMessageDetailsICResult(state, action) {
      state.isLoadingMessageDetails = false;

      if (action.payload.page === 1 || action.payload.page === 0) {
        if (action.payload.channel_type === "email") {
          state.messageDetails = action.payload.data;
        } else {
          state.messageDetails = action.payload.data?.reverse();
        }
      } else {
        if (action.payload.channel_type === "email") {
          state.messageDetails = state.messageDetails.concat(
            action.payload.data
          );
        } else {
          state.messageDetails = state.messageDetails.concat(
            action.payload.data?.reverse()
          );
        }
      }

      if (
        action.payload.channel_type === "facebook_comment" ||
        action.payload.channel_type === "instagram_comment" ||
        action.payload.data.length < 20
      ) {
        state.hasMoreIC = false;
      } else {
        state.hasMoreIC = true;
      }
    },
    $selectedMessage(state, action) {
      state.selectedMessage = action.payload;
    },
    getStatusIC() {},
    getStatusICResult(state, action) {
      state.statusIC = action.payload;
    },
    updateStatusIC() {},
    getTagsIC() {},
    getTagsICResult(state, action) {
      state.tags = action.payload;
    },
    addTagIC() {},
    addTagICResult(state, action) {
      if (action.payload?.interactiondetail_id) {
        const index = state.messageDetails.findIndex(
          (item) => item?.id === action.payload?.interactiondetail_id
        );
        if (index > -1) {
          let tempMessageDetails = [...state.messageDetails];
          if (tempMessageDetails[index]?.interactionDetailTags === null) {
            tempMessageDetails[index] = {
              ...tempMessageDetails[index],
              interactionDetailTags: [],
            };
          }

          tempMessageDetails[index]?.interactionDetailTags?.push(
            action.payload
          );
          state.messageDetails = tempMessageDetails;
        }
      } else {
        let tempAssigned = [...state.assignedMessages];
        let tempCompleted = [...state.completedMessages];
        const interactionIDAssigned = tempAssigned.findIndex(
          (item) => item?.interaction_id === action.payload?.interaction_id
        );
        const interactionIDCompleted = tempCompleted.findIndex(
          (item) => item?.interaction_id === action.payload?.interaction_id
        );
        if (interactionIDAssigned !== -1) {
          if (tempAssigned[interactionIDAssigned]?.interactionTags === null) {
            tempAssigned[interactionIDAssigned] = {
              ...tempAssigned[interactionIDAssigned],
              interactionTags: [],
            };
          }

          tempAssigned[interactionIDAssigned]?.interactionTags?.push(
            action.payload
          );
          state.assignedMessages = tempAssigned;
        }
        if (interactionIDCompleted !== -1) {
          if (tempCompleted[interactionIDCompleted]?.interactionTags === null) {
            tempCompleted[interactionIDCompleted] = {
              ...tempCompleted[interactionIDCompleted],
              interactionTags: [],
            };
          }

          tempCompleted[interactionIDCompleted]?.interactionTags?.push(
            action.payload
          );
          state.completedMessages = tempCompleted;
        }

        if (
          state.selectedMessage?.interaction_id ===
          action.payload?.interaction_id
        ) {
          if (state.selectedMessage?.interactionTags === null) {
            state.selectedMessage = {
              ...state.selectedMessage,
              interactionTags: [],
            };
          }
          state.selectedMessage.interactionTags.push(action.payload);
        }
      }
    },
    deleteTagIC() {},
    deleteTagICResult(state, action) {
      if (action.payload?.interactiondetail_id) {
        const index = state.messageDetails.findIndex(
          (item) => item?.id === action.payload?.interactiondetail_id
        );
        if (index > -1) {
          let tempMessageDetails = [...state.messageDetails];
          const indexInteraction = tempMessageDetails[
            index
          ]?.interactionDetailTags.findIndex(
            (item) => item?.id === action.payload?.interaction_tag_id
          );
          if (indexInteraction !== -1) {
            tempMessageDetails[index]?.interactionDetailTags?.splice(
              indexInteraction,
              1
            );
            state.completedMessages = tempMessageDetails;
          }
        }
      } else {
        let tempAssigned = [...state.assignedMessages];
        let tempCompleted = [...state.completedMessages];
        const interactionIDAssigned = tempAssigned.findIndex(
          (item) => item?.interaction_id === action.payload?.interaction_id
        );
        const interactionIDCompleted = tempCompleted.findIndex(
          (item) => item?.interaction_id === action.payload?.interaction_id
        );
        if (interactionIDAssigned !== -1) {
          const indexInteraction = tempAssigned[
            interactionIDAssigned
          ]?.interactionTags.findIndex(
            (item) => item?.id === action.payload?.interaction_tag_id
          );
          if (indexInteraction !== -1) {
            tempAssigned[interactionIDAssigned]?.interactionTags?.splice(
              indexInteraction,
              1
            );
            state.assignedMessages = tempAssigned;
          }
        }
        if (interactionIDCompleted !== -1) {
          const indexInteraction = tempCompleted[
            interactionIDCompleted
          ]?.interactionTags.findIndex(
            (item) => item?.id === action.payload?.interaction_tag_id
          );
          if (indexInteraction !== -1) {
            tempCompleted[interactionIDCompleted]?.interactionTags?.splice(
              indexInteraction,
              1
            );
            state.completedMessages = tempCompleted;
          }
        }
      }
    },
    createTagIC() {},
    $addTag(state, action) {
      state.addTag = action.payload;
    },
    $addGroup(state, action) {
      state.addGroup = action.payload;
    },
    $addRecordIC(state, action) {
      state.addRecordIC = action.payload;
    },
    disableBotIC() {},
    sendMessageIC() {},
    sendMessageWithFileIC() {},
    completeConversationIC() {},
    uncompleteConversationIC() {},
    $newMessage(state, action) {
      state.newMessage = action.payload;
      const index = state.assignedMessages.findIndex(
        (item) => item?.interaction_id === action.payload?.interaction_id
      );
      const indexCompleted = state.completedMessages.findIndex(
        (item) => item?.interaction_id === action.payload?.interaction_id
      );
      if (index > -1) {
        const newAssignedMessages = [...state.assignedMessages];
        newAssignedMessages[index] = {
          ...newAssignedMessages[index],
          ...action.payload,
        };
        state.assignedMessages = newAssignedMessages;
      }
      if (indexCompleted > -1) {
        const newCompletedMessages = [...state.completedMessages];
        newCompletedMessages[index] = {
          ...newCompletedMessages[index],
          ...action.payload,
        };
        state.completedMessages = newCompletedMessages;
      }
    },
    $newMessageInternal(state, action) {
      state.newMessageInternal = action.payload;
      const index = state.internalMessages.findIndex(
        (item) => item?.interaction_id === action.payload?.interaction_id
      );
      if (index > -1) {
        const newInternalMessages = [...state.internalMessages];
        newInternalMessages[index] = {
          ...newInternalMessages[index],
          ...action.payload,
        };
        state.internalMessages = newInternalMessages;
      }
    },
    addNewMessage(state, action) {
      if (
        !state.messageDetails?.find(
          (item) =>
            item?.id === action.payload?.id ||
            item?.id === action.payload?.interaction_detail_id
        )
      ) {
        state.messageDetails = [action.payload, ...state.messageDetails];
      } else {
        const indexMessage = state.messageDetails?.findIndex(
          (item) =>
            item?.id === action.payload?.id ||
            item?.id === action.payload?.interaction_detail_id
        );
        if (indexMessage > -1) {
          let tempMessageDetails = [...state.messageDetails];

          tempMessageDetails[indexMessage] = {
            ...tempMessageDetails[indexMessage],
            ...action.payload,
          };
          state.messageDetails = tempMessageDetails;
        }
      }

      let temp = [...state.assignedMessages];
      const findIndex = temp.findIndex(
        (item) => item?.interaction_id === action.payload?.interaction_id
      );
      if (findIndex !== -1) {
        temp[findIndex] = {
          ...temp[findIndex],
          ...action.payload,
        };
      }
      state.assignedMessages = temp;
    },
    addNewMessageInternal(state, action) {
      if (
        !state.messageDetails?.find(
          (item) =>
            item?.id === action.payload?.id ||
            item?.id === action.payload?.interaction_detail_id
        )
      ) {
        state.messageDetails = [action.payload, ...state.messageDetails];
      } else {
        const indexMessage = state.messageDetails?.findIndex(
          (item) =>
            item?.id === action.payload?.id ||
            item?.id === action.payload?.interaction_detail_id
        );
        if (indexMessage > -1) {
          let tempMessageDetails = [...state.messageDetails];

          tempMessageDetails[indexMessage] = {
            ...tempMessageDetails[indexMessage],
            ...action.payload,
          };
          state.messageDetails = tempMessageDetails;
        }
      }

      let temp = [...state.internalMessages];
      const findIndex = temp.findIndex(
        (item) => item?.interaction_id === action.payload?.interaction_id
      );
      if (findIndex !== -1) {
        temp[findIndex] = {
          ...temp[findIndex],
          ...action.payload,
        };
      }
      state.internalMessages = temp;
    },
    resgisterSignalrIC() {},
    registerConnectionIntervalIC() {},
    getQuickMessagesIC() {},
    getQuickMessagesICResult(state, action) {
      state.quickMessages = action.payload;
    },
    getUserToAddIC() {},
    getUserToAddICResult(state, action) {
      state.userToAdd = action.payload;
    },
    $addAgent(state, action) {
      state.addAgent = action.payload;
    },
    addAgentIC() {},
    transferAgentIC() {},
    $transferAgent(state, action) {
      state.transferAgent = action.payload;
    },
    searchMessagesIC(state) {
      state.isSearchMessages = true;
    },
    searchMessagesICResult(state, action) {
      state.searchMessages = action.payload;
      state.isSearchMessages = false;
    },
    setSelectedSearchMessage(state, action) {
      state.selectedSearchMessage = action.payload;
    },
    getIndexMessageIC() {},
    getIndexMessageICResult(state, action) {
      state.indexMessage = action.payload;
    },
    getFacebookPostIC() {},
    getFacebookPostICResult(state, action) {
      state.facebookPost = action.payload;
    },
    getListSocialRegisterIC() {},
    getListSocialRegisterICResult(state, action) {
      state.listSocialRegister = action.payload;
    },
    disconnectSignalRIC() {},
    reconnectSignalRIC() {},
    getStateListIC() {},
    getStateListICResult(state, action) {
      state.stateList = action.payload;
    },
    setFilter(state, action) {
      state.filter = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
    },
    setMeta(state, action) {
      state.meta = action.payload;
    },
    setListInteractionSelected(state, action) {
      state.listInteractionSelected = action.payload;
    },
    getSocialPage() {},
    getSocialPageResult(state, action) {
      state.socialPage = action.payload;
    },
    getInternalMessages(state, action) {
      state.isLoadingInternalMessages = true;
    },
    getInternalMessagesResult(state, action) {
      if (state.metaGroup.page === 1) {
        state.internalMessages = action.payload.data;
      } else {
        state.internalMessages = state.internalMessages.concat(
          action.payload.data
        );
      }
      state.isLoadingInternalMessages = false;
      if (action.payload.data?.length < 10) {
        state.metaGroup = {
          ...state.metaGroup,
          hasMore: false,
        };
      }
      if (action.payload.is_get_back) {
        const index = state.internalMessages.findIndex(
          (item) => item.interaction_id === action.payload.is_get_back
        );
        const item = state.internalMessages.find(
          (item) => item.interaction_id === action.payload.is_get_back
        );
        if (index > -1) {
          state.selectedMessage = item;
          state.isActive = index;
        }
      }
    },
    addNewInternalMessage(state, action) {
      state.internalMessages = [action.payload, ...state.internalMessages];
    },
    getInternalMessagesSearch() {},
    getInternalMessagesSearchResult(state, action) {
      state.internalMessagesSearch = action.payload;
    },
    setMetaGroup(state, action) {
      state.metaGroup = action.payload;
    },
    addGroupIC() {},
    getProductList() {},
    getProductListResult(state, action) {
      if (action.payload.page === 1 || action.payload.page === 0) {
        state.productList = action.payload.data;
      } else {
        state.productList = state.productList.concat(action.payload.data);
      }
      if (action.payload?.data?.length < 20) {
        state.productListMeta = {
          ...state.productListMeta,
          hasMore: false,
        };
      }
    },
    setProductListMeta(state, action) {
      state.productListMeta = action.payload;
    },
    setProductSelected(state, action) {
      state.productSelected = action.payload;
    },
    getCustomer() {},
    getCustomerResult(state, action) {
      state.customer = action.payload;
    },
    setUnseen(state, action) {
      state.isUnseen = action.payload;
    },
    getMemberList() {},
    getMemberListResult(state, action) {
      state.memberList = action.payload;
    },
    getUserById() {},
    getUserByIdResult(state, action) {
      state.userById = action.payload;
    },
    leaveGroup() {},
    getBackChat() {},
    getButtonsIntegration() {},
    getButtonsIntegrationResult(state, action) {
      state.buttonsIntegration = action.payload;
    },
    updateInteractionState() {},
    facebookLikeComment(state, action) {
      state.isLoadingCommentActions.like = action.payload.interactiondetail_id;
    },
    facebookLikeCommentResult(state, action) {
      state.isLoadingCommentActions.like = "";
      const index = state.messageDetails.findIndex(
        (item) => item?.id === action.payload?.interactiondetail_id
      );
      if (index > -1) {
        let tempMessageDetails = [...state.messageDetails];
        tempMessageDetails[index] = {
          ...tempMessageDetails[index],
          is_like: !tempMessageDetails[index].is_like,
        };
        state.messageDetails = tempMessageDetails;
      }
    },
    facebookHideComment(state, action) {
      state.isLoadingCommentActions.hide = action.payload.interaction_detail_id;
    },
    facebookHideCommentResult(state, action) {
      state.isLoadingCommentActions.hide = "";
      let tempMessageDetails = [...state.messageDetails];

      if (action.payload?.parent_message) {
        state.messageDetails = _.map(tempMessageDetails, (item) => ({
          ...item,
          comment_state: _.get(action, "payload.comment_state"),
        }));
      } else {
        const index = state.messageDetails.findIndex(
          (item) => item?.id === action.payload?.interaction_detail_id
        );
        if (index > -1) {
          tempMessageDetails[index] = {
            ...tempMessageDetails[index],
            comment_state: _.get(action, "payload.comment_state"),
          };
          state.messageDetails = tempMessageDetails;
        }
      }
    },
    facebookRemoveComment(state, action) {
      state.isLoadingCommentActions.remove =
        action.payload.interaction_detail_id;
    },
    facebookRemoveCommentResult(state, action) {
      state.isLoadingCommentActions.remove = "";
      let tempMessageDetails = [...state.messageDetails];

      if (action.payload?.parent_message) {
        state.messageDetails = _.map(tempMessageDetails, (item) => ({
          ...item,
          comment_state: _.get(action, "payload.comment_state"),
        }));
      } else {
        const index = state.messageDetails.findIndex(
          (item) => item?.id === action.payload?.interaction_detail_id
        );
        if (index > -1) {
          tempMessageDetails[index] = {
            ...tempMessageDetails[index],
            comment_state: _.get(action, "payload.comment_state"),
          };
          state.messageDetails = tempMessageDetails;
        }
      }
    },
    sendMessDirectCustomer() {},
    setAddGroupMember(state, action) {
      state.addGroupMember = action.payload;
    },
    addGroupMember() {},
    removeGroupMember() {},
    setForwardMessage(state, action) {
      state.forwardMessage = action.payload;
    },
    forwardMessage() {},
    messageRecall() {},
    messageRecallResult(state, action) {
      let tempMessageDetails = [...state.messageDetails];

      const index = state.messageDetails.findIndex(
        (item) => item?.id === action.payload?.id
      );
      if (index > -1) {
        tempMessageDetails[index] = {
          ...tempMessageDetails[index],
          is_active: false,
        };
        state.messageDetails = tempMessageDetails;
      }
    },
    updateMessage() {},
    setUpdateMessage(state, action) {
      state.updateMessage = action.payload;
    },
    updateMessageResult(state, action) {
      let tempMessageDetails = [...state.messageDetails];

      const index = state.messageDetails.findIndex(
        (item) => item?.id === action.payload?.id
      );
      if (index > -1) {
        tempMessageDetails[index] = {
          ...tempMessageDetails[index],
          is_edit: true,
          content_text: action.payload?.content_text,
        };
        state.messageDetails = tempMessageDetails;
      }
    },
    pinMessage() {},
    pinMessageResult(state, action) {
      let tempMessageDetails = [...state.messageDetails];

      const index = state.messageDetails.findIndex(
        (item) => item?.id === action.payload?.interactiondetail_id
      );
      if (index > -1) {
        tempMessageDetails[index] = {
          ...tempMessageDetails[index],
          is_pin_message: true,
        };
        state.messageDetails = tempMessageDetails;
      }
    },
    setPinMessage(state, action) {
      state.pinMessage = action.payload;
    },
    unpinMessage() {},
    unpinMessageResult(state, action) {
      let tempMessageDetails = [...state.messageDetails];

      _.forEach(action.payload?.list_id, (id) => {
        const index = state.messageDetails.findIndex((item) => item?.id === id);
        if (index > -1) {
          tempMessageDetails[index] = {
            ...tempMessageDetails[index],
            is_pin_message: false,
          };
        }
      });
      state.messageDetails = tempMessageDetails;
    },
    getListPinMessage() {},
    getListPinMessageResult(state, action) {
      state.pinMessageList = action.payload;
    },
    unmountICChat: () => initialState,
  },
});

//Reducer
export default slice.reducer;

//Actions
export const {
  getLiveChatTemplate,
  getLiveChatTemplateResult,
  updateLiveChatTemplate,
  getConfigIC,
  getConfigICResult,
  getAdvancedConfigIC,
  getAdvancedConfigICResult,
  getAllUserIC,
  getAllUserICResult,
  getChatBotIC,
  getChatBotICResult,
  getListMessagesAssignedIC,
  getListMessagesAssignedICResult,
  setListMessagesAssignedIC,
  getListMessagesCompletedIC,
  getListMessagesCompletedICResult,
  setListMessagesCompletedIC,
  $currentPageIC,
  $recordPerPageIC,
  $isActive,
  getMessageDetailsIC,
  getMessageDetailsICResult,
  $selectedMessage,
  getStatusIC,
  getStatusICResult,
  updateStatusIC,
  getTagsIC,
  getTagsICResult,
  addTagIC,
  addTagICResult,
  deleteTagIC,
  deleteTagICResult,
  createTagIC,
  $addTag,
  $addGroup,
  $addRecordIC,
  disableBotIC,
  sendMessageIC,
  sendMessageWithFileIC,
  completeConversationIC,
  uncompleteConversationIC,
  $newMessage,
  $newMessageInternal,
  addNewMessage,
  addNewMessageInternal,
  resgisterSignalrIC,
  registerConnectionIntervalIC,
  getQuickMessagesIC,
  getQuickMessagesICResult,
  $addAgent,
  getUserToAddIC,
  getUserToAddICResult,
  addAgentIC,
  transferAgentIC,
  $transferAgent,
  searchMessagesIC,
  searchMessagesICResult,
  setSelectedSearchMessage,
  getIndexMessageIC,
  getIndexMessageICResult,
  getFacebookPostIC,
  getFacebookPostICResult,
  getListSocialRegisterIC,
  getListSocialRegisterICResult,
  disconnectSignalRIC,
  reconnectSignalRIC,
  getStateListIC,
  getStateListICResult,
  setFilter,
  setSearch,
  setMeta,
  setMetaGroup,
  setListInteractionSelected,
  getSocialPage,
  getSocialPageResult,
  getInternalMessages,
  getInternalMessagesResult,
  addNewInternalMessage,
  getInternalMessagesSearch,
  getInternalMessagesSearchResult,
  addGroupIC,
  getProductList,
  getProductListResult,
  setProductListMeta,
  setProductSelected,
  getCustomer,
  getCustomerResult,
  setUnseen,
  getMemberList,
  getMemberListResult,
  getUserById,
  getUserByIdResult,
  leaveGroup,
  getBackChat,
  getButtonsIntegration,
  getButtonsIntegrationResult,
  updateInteractionState,
  facebookLikeComment,
  facebookLikeCommentResult,
  facebookHideComment,
  facebookHideCommentResult,
  facebookRemoveComment,
  facebookRemoveCommentResult,
  sendMessDirectCustomer,
  setAddGroupMember,
  addGroupMember,
  removeGroupMember,
  setForwardMessage,
  forwardMessage,
  messageRecall,
  messageRecallResult,
  updateMessage,
  setUpdateMessage,
  updateMessageResult,
  pinMessage,
  pinMessageResult,
  setPinMessage,
  unpinMessage,
  unpinMessageResult,
  getListPinMessage,
  getListPinMessageResult,
  unmountICChat,
} = slice.actions;
